import { Button, ListItem } from "@mui/material";
import styled from "styled-components";



interface IMenuProps {
    expand?: boolean;
    hijos?: boolean;
    modo? : any;
}

export const ListItemContainer = styled(ListItem)<IMenuProps>`
    ${p => p.modo === "oscuro" 
    ?`
        background-color: ${p.expand ? '#E6E6E6' : 'transparent'};
        color: ${p.expand ? '#3C3B39' : '#E6E6E6'};

        .MuiButtonBase-root {
            color: ${ p.expand ? '#3C3B39' : '#E6E6E6'};
        }
    `:`
        background-color: ${p.expand ? '#E6E6E6' : 'transparent'};
        color: '#3C3B39'};
    `}      

    &.MuiButtonBase-root{
        padding: 8px 16px !important;
    }
`;

